module.exports = "/_next/static/images/ef04bbada9f8deeb2a55f09376ce925d-cuenta-card-lg.png";